
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { venuesDetailData } from '../../../mocks/venuesDetail';

export default function VenueCard({ venue }: { venue: typeof venuesDetailData[number] }) {
  const [hovered, setHovered] = useState(false);

  return (
    <article
      className={`bg-white rounded-lg border border-gray-100 overflow-hidden transition-all duration-300 ${hovered ? 'shadow-md border-gray-200' : 'shadow-sm'}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="p-6">
        <div className="flex items-start gap-4 mb-5">
          <div className="w-12 h-12 flex items-center justify-center bg-gray-900 text-white rounded-lg flex-shrink-0">
            <i className={`${venue.icon} text-xl`}></i>
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-base font-bold text-gray-900 leading-tight">{venue.name}</h3>
            <div className="flex items-center gap-2 mt-1 flex-wrap">
              <span className="text-xs text-gray-500 flex items-center gap-1">
                <i className="ri-map-pin-2-line text-xs"></i>
                {venue.area}
              </span>
              <span className="text-gray-300">|</span>
              <span className="text-xs text-gray-500 flex items-center gap-1">
                <i className="ri-group-line text-xs"></i>
                収容 {venue.capacity}
              </span>
            </div>
          </div>
        </div>

        <p className="text-sm text-gray-600 leading-relaxed mb-4">{venue.description}</p>

        <div className="space-y-2 mb-5">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
              <i className="ri-map-pin-line text-gray-400 text-sm"></i>
            </div>
            <span>{venue.address}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
              <i className="ri-phone-line text-gray-400 text-sm"></i>
            </div>
            <span>{venue.phone}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
              <i className="ri-music-line text-gray-400 text-sm"></i>
            </div>
            <span>{venue.genre}</span>
          </div>
        </div>

        <div className="border-t border-gray-100 pt-4">
          <p className="text-xs text-gray-400 font-medium uppercase tracking-wider mb-3">外部リンク</p>
          <div className="flex flex-wrap gap-2">
            {venue.links.map((link, idx) => (
              <a
                key={idx}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gray-50 hover:bg-gray-100 text-gray-700 text-xs rounded-md transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className={`${link.icon} text-sm`}></i>
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </article>
  );
}
